const UPDATE_SUSPENDED_REASON = gql`
    mutation UpdateSuspendedReason($input: UpdateSuspendedReasonInput!) {
        updateSuspendedReason(input: $input) {
            message
        }
    }
`;
export default UPDATE_SUSPENDED_REASON;
